import { Injectable } from '@angular/core';
import { FBFieldList, FormBuilderService } from '@fry/lib/forms';
import { EasFormGroup, EasFormService } from '@fry/components/common/easform';
import { EasFieldGroup, EasFieldType } from '@fry/components/common/easform/easform.interfaces';
import { Observable, of, throwError } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { Venue, VenuesStore } from '@fry/booking/lib';

@Injectable()
export class VenueEditForm {
  private easFormGroup: EasFormGroup;

  constructor(
    private builder: FormBuilderService,
    private easForm: EasFormService,
    private venues: VenuesStore
  ) {}

  private _otherFields = [
    {
      id: 'code',
      type: 'string',
      title: $localize `Code`
    },
    {
      id: 'address',
      type: 'string',
      title: $localize `Address`
    },
    {
      id: 'city',
      type: 'string',
      title: $localize `City`
    },
    {
      id: 'post_code',
      type: 'string',
      title: $localize `Post Code`
    },
    {
      id: 'country',
      type: 'string',
      title: $localize `Country`
    }
  ];

  private _getFields(): FBFieldList {
    return [
      {
        id: 'name',
        type: 'string',
        title: $localize `Name`
      },
      ...this._otherFields
    ];
  }

  private getFields() {
    return this.builder.buildForm({ fields: this._getFields() }, {}).pipe(
      map(fields => {
        const group: EasFieldGroup = {
          id: 'root',
          type: EasFieldType.Group,
          fields: this.builder.transformToEas(fields),
          options: { readOnly: false }
        };
        return group;
      })
    );
  }

  init(venue: Venue): Observable<EasFormGroup> {
    return this.getFields().pipe(
      tap(data => console.log('Fields', data)),
      switchMap(group => of(this.easForm.createForm(group, venue.doc))),
      tap(easGroup => (this.easFormGroup = easGroup))
    );
  }

  // @PreventDoubleSubmission()
  submit(venue: Venue): Observable<Venue> {
    if (this.easFormGroup.control.invalid) {
      return throwError($localize `Please review the form`);
    }

    console.log(this.easFormGroup.getValue());
    venue.doc = { ...venue.doc, ...this.easFormGroup.getValue() };
    venue.orig = { ...venue.doc, ...this.easFormGroup.getValue() };

    return this.venues.save(venue);
  }

  get pristine() {
    if (!this.easFormGroup) {
      return true;
    }
    return this.easFormGroup.control.pristine;
  }
}
